module.exports = __webpack_public_path__ + "img/character-4@2x.059abb80.png";